import { createTheme } from '@mui/material'

declare module '@mui/material/styles' {
  interface Palette {
    gradient: Palette['primary']
  }
  interface PaletteOptions {
    gradient: PaletteOptions['primary']
  }
}

/**
 * We later can easily change the default
 * color palettes here
 * https://mui.com/material-ui/customization/palette
 */
const theme = createTheme({
  palette: {
    primary: {
      main: '#000000'
    },
    secondary: {
      main: '#4ec2ec',
      light: '#DCF6FF'
    },
    gradient: {
      main: '#50ecc6'
    }
  }
})

export { theme }
